import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Dynamically load the widget script
    const script = document.createElement("script");
    script.src = "https://quickbuy-v2.ibanera.com/index.js";
    script.id = "QuickBuyScript";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup if component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center", // vertical center
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div
        id="WidgetContainer"
        data-userReference="WidgetUserReference"
        data-clientSignature="BBF887DB-362A-46D1-8FC9-3CB9213B47FF"
        data-quickBuyKey="BB195B85-5F95-4012-AB35-1D22DA104F46"
        style={{
          backgroundColor: "#fff",
          maxWidth: "650px",
          width: "100%",
          height: "auto",
          minHeight:"400px",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      ></div>
    </div>
  );
}

export default App;
